export default __webpack_public_path__ + "9f3be5f06ae42ee85f6f0fc004c41da4.svg";